<template>
  <div id="app">
    <img src="https://cdn-icons-png.flaticon.com/512/732/732220.png" width="48" height="48">

    <h2>Formatos en Excel</h2>
    <hr>
<br>

     <button @click="downloadFile" style="display: inline-block;border-radius: 5px;text-align: center;font-size: 14px;height:64px;width:200px;cursor:pointer;background-color: #4CAF50;color: white;border-color: #74ad77;border-style: solid; border-width: 2px;"> <b>Descargar Formato Tinas</b> </button>

  </div>
</template>

<script>
let xlsx = require("json-as-xlsx")
import axios from 'axios';

export default {
name: "App",

  methods: {
    downloadFile: async () => {

      var json = await axios.get('https://senfucen.firebaseio.com/formato_tinas.json');
      var content = json.data;


    let data = [
      {
        sheet: "SefuCen",
        columns: [
          { label: "Tina", value: "tina" },
          { label: "Fecha", value: "fecha" },
          { label: "Proveedor", value: "proveedor" },
          { label: "Producto", value: "producto" },
          { label: "Talla", value: "talla" },
          { label: "Cantidad", value: "cantidad" }
        ],
        content: content
      }
    ]

    let settings = {
            fileName: "SenfuCen_Tinas",
          }

      console.log(JSON.stringify(data));

       xlsx(data, settings);
      }
  },
};
</script>
